import AWS from 'aws-sdk';
import {Auth} from 'aws-amplify';

const submitFeedback = feedback => {

  return Auth.currentCredentials()
  .then(credentials => {

    const S3 = new AWS.S3(Auth.essentialCredentials(credentials));

    const id = `${feedback.user}-id${Date.now()}`;

    feedback.id = id;

    const params = {
      Bucket: 'weaveability-basis-utilities-storage',
      Key: `feedback/feedback-${id}.json`,
      Body: JSON.stringify(feedback)
    };

    return S3.upload(params).promise();

  })
  .catch(err => {
    console.log(err);
  });

};

export default submitFeedback;


// WEBPACK FOOTER //
// ./src/components/content/feedback/utils/submitFeedback.js